import React from 'react';
import styled from '@emotion/styled';
import { IRadioButtonProps, RadioButton } from '../../../../../../ui';
import { ISubcategory } from './types';
import { getNestedInputName } from '../nested-input/getNestedInputName';
import { useExtrasFormContext } from '../helpers/useExtrasFormContext';
import { Path } from 'react-hook-form';
import { IExtrasFormData } from '../IExtrasFormData';
import { OptionLabel } from '../option/Option';
import { stripPriceFromName } from '../helpers/stripPriceFromName';

export interface ISubcategorySelectorProps<TCategoryId, TSubcategoryId>
	extends Omit<IRadioButtonProps, 'id' | 'onSelect' | 'ref' | 'label'> {
	categoryId: TCategoryId;
	subcategory: ISubcategory<TSubcategoryId>;
}

export const SubcategoryRadioButton = <
	TCategoryId extends string | number,
	TSubcategoryId extends string | number,
>({
	categoryId,
	subcategory,
	...rest
}: ISubcategorySelectorProps<TCategoryId, TSubcategoryId>) => {
	const { id, nestedInputLevel, price } = subcategory;
	const { register } = useExtrasFormContext();

	const hasPriceInName = subcategory.name.includes('$');

	const name = getNestedInputName(
		nestedInputLevel,
		'selected',
	) as Path<IExtrasFormData>;

	return (
		<>
			<StyledSubcategoryRadioButton
				value={id}
				label={
					<OptionLabel
						name={stripPriceFromName(subcategory.name)}
						price={hasPriceInName ? price : undefined}
					/>
				}
				{...rest}
				{...register(name)}
			/>
		</>
	);
};

export const StyledSubcategoryRadioButton = styled(RadioButton)`
	margin-right: 24px;
`;
